import { render } from "./LbrxServicesPaginator.vue?vue&type=template&id=f1a0df02&scoped=true"
import script from "./LbrxServicesPaginator.vue?vue&type=script&lang=js"
export * from "./LbrxServicesPaginator.vue?vue&type=script&lang=js"

import "./LbrxServicesPaginator.vue?vue&type=style&index=0&id=f1a0df02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a0df02"]])

export default __exports__